<template>
<!-- 상태 변경 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23">상태 변경 ({{name}})</p>
                        <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 pt-10">
                            - 변경하고자 하는 항목을 체크해 주세요.
                        </p>
                        <div class="mt-30">
                            <table class="clear admin-table-row mb-20 table-auto">
                                <thead>
                                    <tr>
                                        <th class="w-150px">
                                            <input type="checkbox" v-model="useWait" name="" id=""> 대기 상태
                                        </th>
                                        <td>
                                            <select v-model="status" name="" id="">
                                                <option value="">대기상태</option>
                                                <!-- <option value="Y">대기</option>  -->
                                                <option value="N">신청완료</option>
                                                <option value="C">신청취소</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="w-150px">
                                            <input type="checkbox" v-model="usePay" name="" id=""> 결제 상태
                                        </th>
                                        <td>
                                            <select v-model="payStatus" name="" id="">
                                                <option value="">결제상태</option>
                                                <!-- <option value="Y">결제완료</option>
                                                <option value="N">미결제</option>
                                                <option value="X">결제없음</option> -->
                                                <option value="C">결제취소</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="w-150px">
                                            <input type="checkbox" :disabled="!mobile" v-model="useAlt" true-value="Y" false-value="N" name="" id=""> 알림톡 발송
                                            <p class="mt-05">
                                                <!-- <button class="admin-btn-default" @click="openModal()" data-toggle="modal" data-target="#sms_view">알림톡 문구</button> -->
                                            </p>
                                        </th>
                                        <td>
                                            <div v-if="!mobile">
                                                연락처를 받지 않는 신청 페이지이므로, <br>
                                                알림톡 발송이 불가능합니다.
                                            </div>
                                            <div v-else>
                                                <button class="admin-btn-default" @click="openModal()" data-toggle="modal" data-target="#sms_view">알림톡 문구</button>
                                            </div>
                                            <!-- <input type="text" class="w-100per" placeholder="발신 번호를 입력하세요">
                                            <textarea name="" v-model="smsText" id="" class="w-100per h-150px mt-10" placeholder="내용을 입력하세요"></textarea> -->
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer txt-center">
                        <a class="pointer admin-btn-default btn ml-05" @click="send()">확인</a>
                    </div>
                </div>
                <sms-modal v-if="isModalOpened" @close="closeModal" @applySMSText="applySMSText"></sms-modal>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import SmsModal from '@/components/search/smsModal.vue'
export default {
    props: ['parentSData'],
    components: {
        SmsModal
    },
    data: () => ({
        isModalOpened: false,

        name: '', // 상태 변경할 수강자 이름

        useWait: false, // 대기 상태 사용여부
        usePay: false, // 결제 상태 사용여부
        useAlt: 'N', // 알림톡 발송 사용여부

        status: '', // 대기전체 '', 대기 Y, 신청완료 N, 신청취소 C
        payStatus: '', // '' 전체, Y 결제완료 N 미결제, C 결제없음
        studentSubjectIdx: '', // 보낼 수강자의 고유 idx
        mobile: '',

        smsText: '' // sms문구
    }),

    mounted() {
        console.log('this.parentSData', this.parentSData)
        this.name = this.parentSData.name
        this.studentSubjectIdx = this.parentSData.studentSubjectIdx
        this.mobile = this.parentSData.mobile
    },

    methods: {
        // 알림톡 혹은 메일 발송
        send() {
            if (!this.useWait && !this.usePay) {
                alert('변경할 상태값을 선택해 주세요.')
                return false
            }

            var params = new URLSearchParams()

            params.append('altYn', this.useAlt)
            params.append('studentSubjectIdx', this.studentSubjectIdx)

            if (this.useWait) {
                params.append('status', this.status)
            }

            if (this.usePay) {
                params.append('payStatus', this.payStatus)
            }

            this.axios.put(this.axios.root + this.axios.port + '/admin/change-all-status', params).then(res => {
                console.log('res', res)
                this.$emit('close')
                this.$emit('refresh')
                alert('상태 변경 완료')
                // if (res.data.err === 0) {

                // } else {
                //     alert(res.data.result)
                // }
            }).catch(err => {
                console.log(err)
                alert(err)
            })
        },

        // 검색 모달 열기
        openModal() {
            this.isModalOpened = true
        },

        // 검색 모달 닫기
        closeModal() {
            this.isModalOpened = false
        },

        // 자식 모달에서 SMS 문구 받아옴
        applySMSText(text) {
            this.isModalOpened = false
            this.smsText = text
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }

    &-footer {
        // background: #ccc;
        padding: 10px;
        text-align: right;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
